import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {SharedSettings} from '../models/shared-settings';
import {ActivityBlockingService} from '../services/activity-blocking.service';
import {map, Observable} from 'rxjs';
import {url} from '../helpers/url';
import {ActivityType, PieceRateActivity} from '../models/piece-rate-activity';

@Injectable({
  providedIn: 'root'
})
export class PieceRateActivityService {
    constructor(private http: HttpClient,
                private settings: SharedSettings,
                private activityService: ActivityBlockingService) { }

    getPieceRateActivities(): Observable<PieceRateActivity[]> {
        return this.http.get<PieceRateActivity[]>(this.settings.apiBaseUrl + url`PieceRate/Activities`).pipe(map(activities => {
            activities.forEach(a => {
                a.activityType = [1,8,9].includes(a.id) ? ActivityType.ChepRepair : a.id === 26 ? ActivityType.GmaRepair : ActivityType.Other;
            });
            return activities;
        }));
    }
    getActivitiesByBusinessUnit(businessUnit: string): Observable<PieceRateActivity[]> {
        return this.http.get<PieceRateActivity[]>(this.settings.apiBaseUrl + url`PieceRate/Activities/${businessUnit}`).pipe(map(activities => {
            activities.forEach(a => {
                switch (a.id) {
                    case 1:
                    case 8:
                    case 9:
                        a.activityType = ActivityType.ChepRepair;
                        break;
                    case 26:
                        a.activityType = ActivityType.GmaRepair;
                        break;
                    case 37:
                        a.activityType = ActivityType.PecoRepair;
                        break;
                    default:
                        a.activityType = ActivityType.Other;
                }
            });
            return activities;
        }));
    }
}
